import { db } from "@/utils/firebase";
import { doc, getDoc } from "firebase/firestore";

export const getConstants = async () => {
  try {
    const docRef = doc(db, "constants", "default");
    const data = await getDoc(docRef);

    if (data.exists()) {
      return data.data();
    }
  } catch (error) {
    console.error("Error fetching constants:", error.message || error);
  }
};

export default getConstants;
